import {
  BanknoteArrowDown,
  ChartPie,
  MessageCircleQuestionMark,
  OctagonAlert,
  Trophy,
  UserCog,
  Users,
  WalletCards,
} from "lucide-react";

// `shortcut` is the key that jumps to the page (shown in the sidebar tooltip).
// Items with `children` open a flyout; their own `path` is the default child.
export const NAV_ITEMS = [
  { path: "/overview", label: "Overview", icon: ChartPie, shortcut: "O" },
  { path: "/accounts", label: "Accounts", icon: Users, shortcut: "A" },
  {
    path: "/withdrawals/payouts",
    label: "Withdrawals",
    icon: BanknoteArrowDown,
    children: [
      { path: "/withdrawals/payouts", label: "Payouts", shortcut: "P" },
      { path: "/withdrawals/rewards", label: "Rewards", shortcut: "R" },
    ],
  },
  { path: "/financials", label: "Financials", icon: WalletCards, shortcut: "F" },
  { path: "/risk", label: "Risk Desk", icon: OctagonAlert, shortcut: "D" },
  { path: "/leaderboard", label: "Leaderboard", icon: Trophy, shortcut: "L" },
  { path: "/support", label: "Support", icon: MessageCircleQuestionMark, shortcut: "H" },
  { path: "/team", label: "Team", icon: UserCog, shortcut: "T" },
];

// Every routable page, with child pages flattened out of their parent group.
// Detail pages live under their section's path (e.g. /support/10482) and keep it highlighted.
export const NAV_ROUTES = NAV_ITEMS.flatMap((item) => item.children ?? [item]);

export function isNavItemActive(item, activePath) {
  return item.children
    ? item.children.some((child) => child.path === activePath)
    : item.path === activePath || activePath.startsWith(`${item.path}/`);
}
